export default "__VITE_ASSET__Dk0kCQFm__"